export const parameter_trainingProgramLabelName = "Programa Formativo";
export const parameter_viaAccesoLabelName = "Vía de acceso a los estudios";
export const preregistrationOptionId = "preregistration";
export const enrollmentOptionId = "enrollment";
export const academicRecordOptionId = "academic_record";
export const campusOnlineOptionId = "campus_online";
export const userProfileOptionId = "user_profile";
export const passRegExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#&()?[{}\]:;',.?\/~$^\+=<>])(?!\s).{8,20}$/;
